var _excluded = ["onClick", "disabled", "loading", "type", "children", "className", "loadingWhenClick"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "./style/index.css";
import useThemeColor from "../hooks/useThemeColor";
import { isPromise } from "../utils/promise";
import { Button as AntdButton } from 'antd';
import cx from 'classnames';
import { isFunction } from 'lodash-es';
import React, { useMemo, useState } from 'react';
var Button = function Button(props) {
  useThemeColor();
  var onClick = props.onClick,
    disabled = props.disabled,
    loading = props.loading,
    type = props.type,
    children = props.children,
    className = props.className,
    _props$loadingWhenCli = props.loadingWhenClick,
    loadingWhenClick = _props$loadingWhenCli === void 0 ? true : _props$loadingWhenCli,
    otherProps = _objectWithoutProperties(props, _excluded);
  // 用于控制onClick所触发的加载状态
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setLoading = _useState2[1];
  var shouldShowLoading = useMemo(function () {
    return loading || loadingWhenClick && isLoading;
  }, [loading, loadingWhenClick, isLoading]);
  var handleClick = function handleClick(e) {
    if (loading || isLoading || disabled || !isFunction(onClick)) {
      return;
    }
    var returnOfClick = onClick(e);
    if (isPromise(returnOfClick)) {
      setLoading(true);
      var cancelLoading = function cancelLoading() {
        return setLoading(false);
      };
      returnOfClick.then(cancelLoading, cancelLoading);
    }
  };
  var renderButtonByType = function renderButtonByType() {
    switch (type) {
      case 'icon':
        return /*#__PURE__*/React.createElement(AntdButton, _extends({}, otherProps, {
          type: "text",
          size: "small",
          onClick: handleClick,
          className: cx('dr-button', 'dr-button-icon', className),
          loading: shouldShowLoading
        }), children);
      case 'hiddenLink':
        return /*#__PURE__*/React.createElement(AntdButton, _extends({}, otherProps, {
          type: "link",
          size: "small",
          onClick: handleClick,
          className: cx('dr-button', 'dr-button-hidden-link', className),
          loading: shouldShowLoading
        }), children);
      default:
        return /*#__PURE__*/React.createElement(AntdButton, _extends({}, otherProps, {
          type: type,
          onClick: handleClick,
          className: cx('dr-button', className),
          loading: shouldShowLoading
        }), children);
    }
  };
  return renderButtonByType();
};
export default Button;